module.exports = __webpack_public_path__ + "img/outlooklive.427a02a3.png";